import { Box, Chip, Modal, useMediaQuery } from "@mui/material";
import InformeRender, { InformeModes } from "../Informes/InformeComponents/InformeRender";
import { IInforme } from "../../redux/models/typesInformes";
import { useAppSelector } from "../../redux/store";
import { useMemo } from "react";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 900,
    boxShadow: 24,
    p: 4,
};

const ModalInforme = ({ open, onClose, informe, onSubmit, onPrinted, mode }: { open: boolean, onClose: () => void, informe?: IInforme, onSubmit: (informe: IInforme) => void, mode: InformeModes, onPrinted?: (informe: IInforme) => void }) => {

    const darkMode = useAppSelector(state => state.theme.darkTheme)
    const InformesPorTipo = useAppSelector(state => state.reports.listaDeTiposDeInforme)
    const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
    const _id = informe?._id || 'falso_id'
    const id = informe?.id || 1000

    const memorizedInforme = useMemo(() => informe || { _id }, [informe]);
    const datosInforme: any = informe && InformesPorTipo[informe?.tipo as any]
    const boxWidth = isMobile ? '100%' : '40rem'

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby={`modal-informe-${informe?.tipo}`}
            sx={{
                width: '100%',
            }}
        >
            <Box sx={(theme) => ({
                ...style,
                bgcolor: darkMode ? '#232323' : '#fff',
                width: boxWidth,
                overflow: 'auto',
                maxHeight: '100%',
            })}
                aria-label={`modal-informe-container-${informe?.tipo}`}
            >
                {informe && <InformeRender
                    mode={mode}
                    formName={datosInforme[0].component}
                    onSubmit={(informe_vals) => onSubmit({ ...informe_vals, _id, id })}
                    data={{ ...memorizedInforme, _id } as IInforme}
                    onCancel={() => onClose()}
                    onPrinted={() => onPrinted && onPrinted(informe)}
                />}
            </Box>
        </Modal>

    );
}

export default ModalInforme;

